import Vue from 'vue';
import App from './App.vue';
import axios from './axios';
import i18n from './i18n';
import router from './router.js';
import store from './store';

Vue.prototype.$http = axios;

global.jQuery = require('jquery');
const $ = global.jQuery;
window.$ = $;

import 'promise-polyfill/src/polyfill';
import '../public/css/style.scss';
import './../node_modules/slick-carousel/slick/slick.css';

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
